import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  Validators
} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {CommonService} from '@service/common/common.service';
import {Subject} from 'rxjs';
import {AuthService} from '@service/auth/auth.service';
import {ActivatedRoute} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {NavigationService} from '@service/navigation/navigation.service';

@Component({
    selector: 'app-registration-preactivation-code',
    templateUrl: './registration-preactivation-code.component.html',
    styleUrls: ['./registration-preactivation-code.component.scss'],
    standalone: false
})
export class RegistrationPreactivationCodeComponent implements OnDestroy, OnInit {
  @ViewChild('registrationComplete') registrationComplete: TemplateRef<any> | undefined;
  registrationForm: UntypedFormGroup;
  private destroy$ = new Subject();

  constructor(private fb: UntypedFormBuilder, private common: CommonService, private dialog: MatDialog,
              private activatedRoute: ActivatedRoute, private authService: AuthService, private navigation: NavigationService) {
    this.registrationForm = this.fb.group({
      email: [null, Validators.required],
      code: [null, Validators.required],
      password: [null, Validators.required],
      samePassword: [null, [Validators.required, (): ValidationErrors | null =>
        this.registrationForm?.get('password')?.value === this.registrationForm?.get('samePassword')?.value ? null : {notSamePassword: true}
      ]],
      subscriptionMailchimp: [false, [Validators.required, (): ValidationErrors | null =>
        this.registrationForm?.get('subscriptionMailchimp')?.value === true ? null : {require: true}
      ]],
      policy: this.fb.array([])
    });
    this.registrationForm.get('password')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.registrationForm.get('samePassword')?.updateValueAndValidity();
    });
    this.activatedRoute.queryParamMap
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        const mail = res?.params?.email;
        const otp = res?.params?.otp;
        if (mail) {
          this.registrationForm.get('email')?.setValue(mail);
        }
        if (otp) {
          this.registrationForm.get('code')?.setValue(otp);
        }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.loadPolicyData();
  }

  public checkForm(form: UntypedFormGroup, field: string): string {
    if (form.controls[field].invalid) {
      if (form.controls[field].hasError('required')) {
        return 'Field required.';
      } else if (form.controls[field].hasError('email')) {
        return 'Please enter a valid email address.';
      } else if (form.controls[field].hasError('email')) {
        return 'Please enter a valid email address.';
      } else if (form.controls[field].hasError('password')) {
        return 'Please enter a valid password';
      }
    }
    return '';
  }

  public get getPolicyList(): UntypedFormArray {
    return this.registrationForm.get('policy') as UntypedFormArray;
  }

  public loadPolicyData(): void {
    this.common.getPolicyList('privacy_policy', 'cpq')
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        res.forEach((el: any) => {
          this.getPolicyList.push(new UntypedFormGroup({
            id: new UntypedFormControl(el.id, null),
            description: new UntypedFormControl(el.content, null),
            value: new UntypedFormControl(false, el.isRequired ? [Validators.requiredTrue] : null),
          }));
        });
        this.registrationForm.updateValueAndValidity();
      });
  }

  register(): void {
    const formData = this.registrationForm.getRawValue();
    this.authService.userActivate(formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (!res.error && this.registrationComplete) {
          this.dialog.open(this.registrationComplete, {
            disableClose: true
          });
        }
        if (res.error && res.error.result) {
          this.common.showErrorToast(res.error.result);
        }
    });
  }

  validForm(): boolean {
    return this.registrationForm.valid;
  }

  goToCatalog(): void {
    this.navigation.goToCatalogList();
  }
}
